import { Layout, Panel, } from "@mcleod/components";

export abstract class AutogenLayoutStatusResolution extends Layout {
    panel1: Panel;
}
